var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"landing-app"}},[_c('router-view'),_vm._v(" "),_c('top-toast',{attrs:{"visible":! _vm.online}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }